const enviroments = {
    prd: 'https://hscappssp01.hospitalsaocamilosp.org.br:6010/medicos',
    dev: 'http://172.17.1.252:6009/medicos',
    token: 'eyJhbGciOiJIUzI1NiJ9.YWRtaW4.ll1m6jWs6cogQhav46PE5RaLlmzdaYv0krElFizPpzE'
}

export default enviroments;